export const paths = {
  base: '/',
  no_match: '*',
  bulk_invites: 'bulk-invites',
  app: 'app',
  sign_in: 'sign-in',
  sign_up: 'sign-up',
  reset_password: 'forgot-password',
  setup_password: 'set-password',
  unsubscribe: 'unsubscribe',
  chat: 'chat',
  questionnaire: 'questionnaire',
  preview: 'preview',
  profile: {
    root: 'profile',
    general: 'general',
    password: 'password',
    diseases: 'diseases',
    attributes: 'attributes',
    notifications: 'notifications',
    delete_account: 'delete-account',
    account: 'account',
  },
  trials: 'trials',
  trial_recruitment: 'trial-recruitment',
  trials_library: 'trials-library',
  maintenance: 'maintenance',
  questions_library: {
    root: 'questions-library',
    details: 'details',
    classification: {
      root: 'classification',
      icd_codes: 'icd-codes',
      starters: 'starters',
      tags: 'tags',
    },
    trials: 'trials',
    activity: 'activity',
    merge: 'merge',
    create: 'create',
  },
  compare: 'compare',
  create: 'create',
  criterias: 'criterias',
  volunteers: 'volunteers',
  teams: 'teams',
  milestones: 'milestones',
  collaborators: 'collaborators',
  updates: 'updates',
  trial_invite: 'trial-invite',
  team_trial_invite: 'team-trial-invite',
  notifications: 'notifications',
  hospitals: 'hospitals',
  diseases: 'diseases',
  request_trial: 'request-trial',
  requests: 'requests',
  b2b: 'b2b',
  team: {
    root: 'team',
    general: 'general',
    users: 'users',
    billing: 'billing',
    trials: 'trials',
    panels: 'panels',
    premium: 'premium',
    reporting_scope: 'reporting-scope',
  },
  create_team: 'create-team',
  onboarding: {
    root: 'onboarding',
    criteria_table: 'criteria-table',
    trial_overview: 'trial-overview',
  },
  embedded_chat: 'embedded-chat',
  embedded_chat_v2: 'embedded-chat-v2',
  users: 'users',
  ctdi: 'ctdi',
  surveys: {
    root: 'surveys',
    create: 'create',
    details: 'details',
    questions: 'questions',
    responses: 'responses',
    insights: 'insights',
  },
  panels: {
    root: 'panels',
    create: 'create',
    details: 'details',
    insights: 'insights',
  },
  insights: 'insights',
  milestone: 'milestone',
  select_account: 'select-account',
  predicate_library: {
    root: 'predicate-library',
    library: 'library',
    category: 'library/:predicateLibraryItemId',
    missing: 'missing',
    tiers: 'tiers',
  },
  predicate_questions: {
    root: 'predicate-questions',
    question: ':questionId',
  },
  trials_redesign: {
    root: 'trials-redesign',
    trial: ':trialId',
    overview: 'overview',
    criteria: 'criteria',
    sites: 'sites',
    matching_patients: 'matching-patients',
    companion: 'companion',
    details: 'details',
    teams: 'teams',
    updates: 'updates',
  },
  trials_v2: {
    root: 'trials-v2',
    trials: 'trials',
    cohorts: 'cohorts',
    processed_criteria: 'processed-criteria',
  },
  pipeline: {
    root: 'pipeline',
    trial: ':trialId',
  },
  parity_review: {
    matched_sets: 'matched-sets',
    readiness: 'readiness',
    root: 'parity-review',
    slices: 'slices',
    trials: 'trials',
  },
  partner_reporting: {
    root: 'partner-reporting',
    overview: 'overview',
    trials_overview: 'trials-overview',
    trial_geography: 'trial-geography',
    trial_criteria: 'trial-criteria',
    trial_rejections: 'trial-rejections',
    site_opportunity: 'site-opportunity',
    trial_delays: 'trial-delays',
    criteria_simulator: 'criteria-simulator',
    chatbot: 'chatbot',
    patients_overview: 'patients-overview',
    funnel: 'funnel',
  },
  units: {
    active: 'active',
    queue: 'queue',
    rejected: 'rejected',
    root: 'units',
    standard_units: 'standard-units',
    standard_unit_detail: 'standard-units/:unit',
  },
  parity_routing: {
    history: 'history',
    root: 'parity-routing',
    routing: 'routing',
  },
};
